import axios from 'axios'
export default {

  async add (pos, img) {
    try {
      pos.updated_at = Date.now()
      pos.created_at = Date.now()
      pos.active = true
      delete pos._id

      const response = await axios.post('terminals/add', pos)
      if (response.status === 200) {
        if (img != null) {
          const formData = new FormData()
          formData.append('file', img)
          formData.append('_id', response.data._id)
          formData.append('type', 'terminal')
          await axios.post('files/add', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
        }
        console.log('Pos agregado correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al agregar el pos:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al agregar el pos:', error)
      return false
    }
  },

  async edit (pos, img) {
    try {
      pos.updated_at = Date.now()
      const response = await axios.patch('terminals/update', pos)
      if (response.status === 200) {
        if (img != null) {
          const formData = new FormData()
          formData.append('file', img)
          formData.append('_id', response.data._id)
          formData.append('type', 'terminal')
          await axios.post('files/add', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
        }
        console.log('POS editado correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al editar el pos:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al editar el pos:', error)
      return false
    }
  },

  async changeActive (pos) {
    try {
      pos.active = !pos.active
      pos.updated_at = Date.now()
      const response = await axios.patch('terminals/active', pos)
      if (response.status === 200) {
        console.log('POS editado correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al editar el pos:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al editar el pos:', error)
      return false
    }
  },

  async delete (pos) {
    try {
      pos.deleted_at = Date.now()
      const response = await axios.patch('terminals/delete', pos)
      if (response.status === 200) {
        console.log('POS editado correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al editar el pos:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al editar el pos:', error)
      return false
    }
  },

  async list (businesId, search) {
    try {
      const response = await axios.get('terminals/list?business=' + businesId + '&search=' + search)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  }

}
